// https://github.com/TinderApp/design-system/blob/main/packages/tinder-ui-react/src/components/Button/constants.ts
import { PresetButtonColors, themeCssVar as theme, type ButtonColors } from '@tinderapp/ui-react';

// 'gold' theme
const BUTTON_GOLD_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  background: theme.gradient.backgroundGoldShine,
  foreground: theme.color.foregroundButtonPrimaryOverlay,
};

// 'goldDark' theme
const BUTTON_GOLD_DARK_PROPS: ButtonColors = {
  ...BUTTON_GOLD_PROPS,
  background: theme.gradient.backgroundGold,
  foreground: theme.color.textPrimary,
};

// 'platinum' theme
const BUTTON_PLATINUM_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  background: theme.gradient.revenuePlatinumOnDark,
  foreground: theme.color.textPrimary,
};

// 'platinumDark' theme
const BUTTON_PLATINUM_DARK_PROPS: ButtonColors = {
  ...BUTTON_PLATINUM_PROPS,
  background: theme.gradient.revenuePlatinumShine,
  foreground: theme.color.textPrimaryOverlay,
};

// 'blue' theme
const BUTTON_BLUE_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  background: theme.gradient.backgroundSuperLike,
  foreground: theme.color.textPrimaryOverlay,
};

// 'purple' theme
const BUTTON_PURPLE_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  background: theme.gradient.backgroundBoost,
};

// 'gray' theme
const BUTTON_GRAY_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  background: theme.color.gray15,
};

// 'superboost' theme
const BUTTON_SUPERBOOST_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  background: theme.gradient.backgroundSuperBoost,
};

// tinder select
const BUTTON_SELECT_PROPS: ButtonColors = {
  ...PresetButtonColors.Primary,
  // @TODO, experimental features, should eventually moved to design tokens
  background: `linear-gradient(140deg, ${theme.color.purple60}, ${theme.color.blue50})`,
};

export const BUTTON_THEMES = {
  blue: BUTTON_BLUE_PROPS,
  boost: BUTTON_PURPLE_PROPS,
  cancel: PresetButtonColors.Tertiary,
  gray: BUTTON_GRAY_PROPS,
  gold: BUTTON_GOLD_PROPS,
  goldDark: BUTTON_GOLD_DARK_PROPS,
  outline: PresetButtonColors.Secondary,
  platinum: BUTTON_PLATINUM_PROPS,
  platinumDark: BUTTON_PLATINUM_DARK_PROPS,
  purple: BUTTON_PURPLE_PROPS,
  superboost: BUTTON_SUPERBOOST_PROPS,
  select: BUTTON_SELECT_PROPS,
  primary: PresetButtonColors.Primary,
} as const;

export const BUTTON_VARIANTS = {
  primary: PresetButtonColors.Primary,
  primaryOverlay: PresetButtonColors.PrimaryOverlay,
  primaryAccessible: PresetButtonColors.PrimaryAccessible,
  secondary: PresetButtonColors.Secondary,
  secondaryOverlay: PresetButtonColors.SecondaryOverlay,
  tertiary: PresetButtonColors.Tertiary,
  tertiaryOverlay: PresetButtonColors.TertiaryOverlay,
  neutral: PresetButtonColors.Neutral,
} as const;
